export default __webpack_public_path__ + "static/cashapp-3f97827c1ea9ed1144c3f6c10d45427e.png";